export default "__VITE_ASSET__C2z4hfYA__"